module.exports = __webpack_public_path__ + "img/location.f60c0ff7.png";